export default {
    '.multi-image-container > .container': {
        display: {base: 'block', md: 'flex'},
        margin: '0 -12.5px',
        alignItems: 'center'
    },
    '.multi-image-container.callout-container > .container': {
        display: {base: 'block', sm: 'flex'}
    },
    '.multi-image-container .container .component': {
        padding: '0 12.5px',
        flex: {base: 'none', md: '1'},
        width: '100%',
        marginBottom: '16px'
    },
    '.multi-image-container.callout-container .container .component': {
        flex: {base: 'none', sm: '1'}
    },
    '.multi-image-container-main-block .mobile-slider .multi-image-container > .container': {
        display: ['flex'],
        overflowY: 'scroll',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '> .component': {
            minWidth: {base: '150px', md: '150px', lg: 'unset'},
            maxWidth: '250px',
            width: {base: '69%', md: 'auto'}
        }
    }
}
